/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Showcase_Tagfun1Inputs */

const zh_showcase_tagfun1 = /** @type {(inputs: Showcase_Tagfun1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`趣味学习`)
};

const en_showcase_tagfun1 = /** @type {(inputs: Showcase_Tagfun1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fun Learning`)
};

const es_showcase_tagfun1 = /** @type {(inputs: Showcase_Tagfun1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprendizaje Divertido`)
};

/**
* | output |
* | --- |
* | "Fun Learning" |
*
* @param {Showcase_Tagfun1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const showcase_tagfun1 = /** @type {((inputs?: Showcase_Tagfun1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Showcase_Tagfun1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_showcase_tagfun1(inputs)
	if (locale === "en") return en_showcase_tagfun1(inputs)
	return es_showcase_tagfun1(inputs)
});
export { showcase_tagfun1 as "showcase_tagFun" }